module.exports = __webpack_public_path__ + "static/media/logoBlack.6db47982.svg";